import Vue from 'vue'
import VueRouter from 'vue-router'
import smartDeposit from './modules/smartDeposit'

// const requireAll = ctx =>
//   ctx
//     .keys()
//     .map(ctx)
//     .reduce((acc, cur) => acc.concat(cur.default), [])

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    redirect: '/homePage'
  },
  ...smartDeposit
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
